import React from 'react';
import { bool, object } from 'prop-types';

import CSS from './styles.scss';

import NoteEditor from 'Shared/NoteEditor';
import Read from './Read';


const NoteSlatViews = ({ isNoteEditorOpen, styles }) => {
  return (
    <div className={ CSS['container'] } style={ styles } tabIndex="-1">
      { isNoteEditorOpen
        ? <NoteEditor />
        : <Read />
      }
    </div>
  );
};

NoteSlatViews.propTypes = {
  isNoteEditorOpen: bool,
  styles: object
};


export default NoteSlatViews;
